
import { defineComponent, reactive, watch, toRefs, computed } from 'vue'
import { useInitDataStore } from '@/stores/initDataStore'

export const RESOLUTIONS = {
  MINUTE: 'minute',
  HOUR: 'hour',
  DAY: 'day',
  MONTH: 'month',
  RUISEKI: 'rui',
  TEN_MIN: 'ten_min',
}

export const RESOLUTION_LABELS = {
  [RESOLUTIONS.HOUR]: '時報',
  [RESOLUTIONS.DAY]: '日報',
  [RESOLUTIONS.MONTH]: '月報',
  [RESOLUTIONS.RUISEKI]: '累計雨量',
  [RESOLUTIONS.TEN_MIN]: '10分',
}

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      required: false,
      default: RESOLUTIONS.MINUTE,
    },
  },

  setup(props, { emit }) {
    const initDataStore = useInitDataStore()
    const state = reactive({
      current: props.modelValue,
      label: RESOLUTION_LABELS[RESOLUTIONS.MINUTE],
    })

    const label = computed(() => RESOLUTION_LABELS[state.current])

    const options = computed(() => {
      const initData = initDataStore.initData

      if (!initData || !initData.summaryList) {
        return []
      }

      const times = (initData?.summaryList?.multiStation || [])[0]
      let timeKeys = Object.keys(times)

      timeKeys = timeKeys.filter(key => key !== 'title')

      return timeKeys.map(key => ({
        label: times[key as 'hour' | 'day' | 'month']?.title,
        value: key,
      }))
    })

    watch(
      () => state.current,
      () => {
        emit('update:modelValue', state.current)
      }
    )

    watch(
      () => props.modelValue,
      () => (state.current = props.modelValue)
    )

    return {
      ...toRefs(state),
      label,
      options,
    }
  },
})
